import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { colors } from '../utils/colors';

const RoundNavigationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

const NavigationItem = styled.div`
  display: inline-block;
  background: ${props => (props.active ? colors.g03 : colors.w01)};
  border: 1px solid ${colors.g03};
  border-radius: 50%;
  height: 8px;
  margin-right: 4px;
  width: 8px;
`;

const RoundNavigation = ({ count, progress }) => (
  <RoundNavigationWrapper>
    {[...Array(count).keys()].map(key => (
      <NavigationItem key={key} active={progress === key} />
    ))}
  </RoundNavigationWrapper>
);

RoundNavigation.propTypes = {
  count: PropTypes.number.isRequired,
  progress: PropTypes.number.isRequired
};

export { RoundNavigation };
